











































































































import { Component, Vue } from "vue-property-decorator";
import Layout from "@/components/Layout.vue"; // @ is an alias to /src
import MainSlogan from "@/components/common/MainSlogan.vue";
import WordOnPic from "@/components/common/WordOnPic.vue";
import AssignCard from "@/components/common/AssignCard.vue";
import PicWall from "@/components/common/PicWall.vue";
import ListOnPic from "@/components/common/ListOnPic.vue";

@Component({
  components: {
    Layout,
    MainSlogan,
    WordOnPic,
    AssignCard,
    PicWall,
    ListOnPic,
  },
})
export default class Trip extends Vue {}
